<template>
    <div id="app">
        <v-app id="inspire">
            <v-app id="inspire">
                <v-data-table
                        :headers="headers"
                        :items="notifications"
                        hide-default-footer
                        :loading="!flagResponse"
                >
                    <template v-slot:item.date_notification="{ item }">
                        {{ item.date_notification | timeStampToHuman }}
                    </template>
                    <template slot="no-data">
                        Nenhuma irregularidade encontrada.
                    </template>
                    <template slot="loading">
                        Carregando
                    </template>
                </v-data-table>
            </v-app>
        </v-app>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: "NotificationList",
        props:[
            'plate'
        ],
        data:function () {
            return{
                headers: [
                    { text: 'Data da Irregularidade',sortable: false, value: 'date_notification' },
                    { text: 'Endereço',sortable: false, value: 'address' },
                    { text: 'Status',sortable: false, value: 'status' },
                ],
                notifications: [],
                flagResponse: false,
            }
        },
        mounted(){
            this.searchPlate();
        },
        methods:{
            searchPlate(){
                this.flagResponse = false;
                this.notifications = [];
                axios
                    .get('/api/notification/'+this.plate)
                    .then(response => {
                        this.notifications = response.data.data;
                        this.flagResponse = true;
                    });
            },
        },
        watch:{
            plate: {
                deep: true,
                immediate: true,
                handler () {
                    if(this.plate.length === 7){
                        this.searchPlate();
                    }

                }
            }
        }
    }
</script>

<style scoped>
    .notification-list{
        font-size: 14px;
        font-family: Roboto-Regular;
        color: #58595B;
    }
</style>
